export { default } from './product';